import React from 'react';
import {Col, FormGroup, Row} from "reactstrap";
import {TextControllerRHF} from "../../../../generic/fields";
import {t} from "i18next";
import ManagerComments from '../../../../common/formElements/ManagerComments';


const InsideInfoBlock = ({state, dispatch, control, errors, isArrival, entityName}) => {
    const setAdventureData = (e) => dispatch({type: 'setFormData', payload: e});

    const setComments = (value) => dispatch({ type: 'setForm', payload: { comments_for_manager: value } });

    return (
        <Row className={'pb-3'}>
            <Col xs={12} >
                <h4 className={'display-4'}>{t('adventures.edit.insideInfo')}</h4>
            </Col>
            <Col xs={12} className={'mb-4'}>
                <ManagerComments entity={entityName} id={state.id} data={state.comments_for_manager} setData={setComments} />
            </Col>
            <Col xs={12}>
                <FormGroup>
                    <TextControllerRHF inputName={'client_comment'}  setValue={setAdventureData}
                                       label={isArrival
                                           ? t('adventures.edit.arrivalClientComment')
                                           : t('adventures.edit.travelClientComment')
                                        }
                                       control={control}
                                       errors={errors}
                                       defaultValue={state.client_comment || ''}
                                       placeholder={''}
                                       hint={t('adventures.edit.commentHint')}
                                       rules={{maxLength: 150}}/>
                </FormGroup>
            </Col>
        </Row>
    )
}

export default InsideInfoBlock;